<template>
  <div class="left_col scroll-view">
    <div class="navbar nav_title" style="border: 0;">
      <router-link :to="{ name: 'home' }" class="site_title"
        >{{ $t('loginPage.orderWithTheSmartphone') }} ADMIN</router-link
      >
    </div>

    <div class="clearfix"></div>

    <side-bar-menu />
  </div>
</template>
<script>
import SideBarMenu from '@/components/common/sidebar/SideBarMenu'
export default {
  components: {
    SideBarMenu,
  },
}
</script>
